module.exports = __webpack_public_path__ + "static/media/Impact.f69284ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Impact.png
// module id = 1616
// module chunks = 0